import { createSelector } from 'reselect';

const getBroadcasters = (state) => state.broadcasters;
const getLoading = (state) => state.loading?.isLoading;

export const getBroadcastersState = createSelector(
    [getBroadcasters, getLoading],
    (broadcasters, isLoading) => (
        {
            ...broadcasters,
            isLoading
        }
    )
);
